import { DataMap } from './dataMap';
import { PagingOptions } from '../../interfaces/options';

export class PagingDataMap<T> extends DataMap<T> {
	public pageSize: KnockoutObservable<number>;
	public currentPage: KnockoutObservable<number>;
	public pageCount: KnockoutComputed<number>;
	public pageItems: KnockoutComputed<T[]>;
	public isPreviousPageable: KnockoutComputed<boolean>;
	public isNextPageable: KnockoutComputed<boolean>;
	constructor(
		data: KnockoutObservableArray<T> | KnockoutComputed<T[]> | KnockoutObservable<T[]> | DataMap<T>,
		options: PagingOptions
	) {
		super(data);
		this.pageSize = ko.observable<number>(options.pageSize);
		this.currentPage = ko.observable<number>(1);
		this.pageCount = ko.pureComputed(() => {
			var pageSize = this.pageSize();
			if (pageSize == undefined || pageSize <= 0) {
				return 1;
			} else {
				return Math.ceil(this.data().length / pageSize);
			}
		});
		this.map = ko.pureComputed(() => {
			var data = this.data(),
				pageSize = this.pageSize();
			if (pageSize && data) {
				var currentPage = this.currentPage() >= 1 ? this.currentPage() : 1;
				if (currentPage > this.pageCount() && this.pageCount() > 0) {
					this.currentPage(this.pageCount());
					currentPage = this.pageCount();
				}
				var pageStartIndex = pageSize * (currentPage - 1);
				var pageEndIndex = pageStartIndex + pageSize;
				return data.slice(pageStartIndex, pageEndIndex);
			} else {
				return data;
			}
		});
		this.isPreviousPageable = ko.pureComputed(() => {
			return this.currentPage() > 1;
		});
		this.isNextPageable = ko.pureComputed(() => {
			return this.currentPage() < this.pageCount();
		});
	}
	public page(page: number) {
		page = page > this.pageCount() ? this.pageCount() : page <= 0 ? 1 : page;
		this.currentPage(page);
	}
	public previousPage() {
		if (this.isPreviousPageable()) {
			this.page(this.currentPage() - 1);
		}
	}
	public nextPage() {
		if (this.isNextPageable()) {
			this.page(this.currentPage() + 1);
		}
	}
	public firstPage() {
		if (this.isPreviousPageable()) {
			this.page(1);
		}
	}
	public lastPage() {
		if (this.isNextPageable()) {
			this.page(this.pageCount());
		}
	}
}
